import { forwardRef, Inject, Injectable } from '@angular/core';

import moment from 'moment';

import { DateParserService } from '../../core/services/date-parser.service';
import { NotificationModel } from './typings/notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private _storageKeySuffix = '_notifications_dismissed_on';

  constructor (
    @Inject(forwardRef(() => DateParserService))
    private dateParserService: DateParserService
  ) {}

  dismiss ( notification : NotificationModel ) : void {
    const dismissedOn = moment().toISOString();

    localStorage[ `${ notification.id }${ this._storageKeySuffix }` ] = dismissedOn;
  }

  formatNotifications ( notifications : Array<NotificationModel> ) : Array<NotificationModel> {
    const sortedNotifications = notifications
    .filter(notification => !this.isDismissed(notification))
    .sort((current, next) => {
      if (this.dateParserService.isBeforeDate(current.created_on, next.created_on)) {
        return -1;
      }

      else if (this.dateParserService.isAfterDate(current.created_on, next.created_on)) {
        return 1;
      }

      return 0;
    });

    return sortedNotifications.reverse();
  }

  getDismissesDate ( notification : NotificationModel ) : string {
    return localStorage[ `${ notification.id }${ this._storageKeySuffix }` ];
  }

  isDismissed ( notification : NotificationModel ) : boolean {
    if ( !this.getDismissesDate(notification) ) {
      return false;
    }

    return this.dateParserService.isBeforeDate(notification.created_on, this.getDismissesDate(notification));
  }
}
